export const convertToAmPm = (time) => {
  const [hour, minute] = time.split(":").map(Number);
  const ampmHour = hour % 12 || 12;
  const ampm = hour >= 12 ? "PM" : "AM";
  return `${ampmHour}:${minute.toString().padStart(2, "0")} ${ampm}`;
};
